import styled from "styled-components";

export const Container = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  align-items: center;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 4rem 2.5rem;
  width: 42rem;

  h1 {
    ${(props) => `
      color: ${props.theme.colors.blackTextTitle};
    `}
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 0;
  }

  p {
    color: ${(props) =>
      props.theme.colors.blackTextTitle + props.theme.transparencies.p58};
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 2.4rem;
    margin-top: 2rem;
    padding: 0 1rem;
    text-align: center;
  }
`;

export const MainButton = styled.button`
  ${(props) => `
    background-color: ${props.theme.colors.primaryBlue};
    color: ${props.theme.colors.white};
  `}
  align-items: center;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  display: flex;
  font-size: 1.5rem;
  font-weight: 700;
  height: 5.6rem;
  justify-content: center;
  margin-top: 1rem;
  width: 32.4rem;
`;
